import NoteHistoryAPI from 'remote/notesHistory'
import { apiCapableActionCreator } from '../apiActionHelpers'
import { actions as UIActions } from 'data/ui'
import { FETCH_NOTE_HISTORY } from './actionTypes'

export const fetchNoteHistory = apiCapableActionCreator(
  ({ noteId }) => ({ apiConfig }) => {
    return {
      type: FETCH_NOTE_HISTORY,
      payload: NoteHistoryAPI.fetchNoteHistory(apiConfig, { noteId }),
      meta: { noteId },
    }
  }
)

export const revertHistory = apiCapableActionCreator(
  ({ noteId, to }) => ({ apiConfig, dispatch }) => {
    return {
      type: 'REVERT_HISTORY',
      payload: NoteHistoryAPI.revertNoteHistory(apiConfig, { noteId, to }).then(
        () =>
          dispatch(
            UIActions.createSuccessToasterMessage({
              title: 'Doc successfully reverted to a previous version',
            })
          ),
        () =>
          dispatch(
            UIActions.createWarningToasterMessage({
              title: "We couldn't restore this doc to a previous version",
            })
          )
      ),
      meta: { noteId },
    }
  }
)
